module.exports = __webpack_public_path__ + "static/img/image@2x (9).288fe1db.png";